import { Inline, Text } from '@etg/wings';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { X } from '@phosphor-icons/react';
import React, { useEffect, memo } from 'react';

const toastStyles = css`
  @keyframes toast-in-left {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes toast-in-right {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  animation: toast-in-left 0.7s;
  background: ${etiColors.black};
  border-radius: 3px;
  color: ${etiColors.white};
  justify-content: space-between;
  margin: 0 0 9px;
  padding: 16px;
  position: relative;
  transition: transform 0.6s ease-in;
  transition: 0.3s ease;
  width: 374px;

  [dir='rtl'] & {
    animation: toast-in-right 0.7s;
  }

  @media ${mediaQueries.small.only} {
    width: 338px;
  }
`;

const closeIconStyles = css`
  cursor: pointer;
`;

interface ToastProps {
  description: string;
  id: number;
  autoCloseDuration: number;
  deleteToast: (id: number) => void;
}

const timerList: ReturnType<typeof setTimeout>[] = [];

const Toast = ({ autoCloseDuration, description, deleteToast, id }: ToastProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      deleteToast(id);
    }, autoCloseDuration * 1000);
    timerList.push(timer);

    return () => {
      clearTimeout(timerList[0]);
      timerList.splice(0, 1);
    };
  }, [autoCloseDuration, deleteToast, id]);

  return (
    <Inline
      aria-atomic="true"
      aria-live="polite"
      className={`notification ${toastStyles}`}
      data-testid={`toast-message-${id}`}
      noWrap
      role="alert"
      spacing={16}
    >
      <Text>{description}</Text>
      <X
        className={closeIconStyles}
        color={etiColors.white}
        data-testid="toast-close-icon"
        onClick={() => deleteToast(id)}
        role="button"
        size={22}
        weight="light"
      />
    </Inline>
  );
};

export default memo(Toast);
